module.exports = __webpack_public_path__ + "static/media/SVID_S_4-2.92da48cd.png";